import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationContainerComponent } from '../../../../features/navigation/components/navigation-container/navigation-container.component';
import { ScrollDirective } from '../../../../shared/directives/scroll-directive/scroll-directive.directive';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavigationContainerComponent, ScrollDirective, RouterOutlet],
})
export class MainContentComponent {
  @Input()
  public isNavigationCollapsed: boolean;

  @Output()
  public scrolledToPoint: EventEmitter<void> = new EventEmitter<void>();

  public onScrolledToPoint(): void {
    this.scrolledToPoint.emit();
  }
}
